import React, { useState } from 'react';
import { useSelector } from 'react-redux';
import { FEATURE_HOSTS, PERMISSION_TYPES } from 'Hooks/usePermission/permissions';
import { useIntl } from 'react-intl';
import Button from 'shared/ui/Button';
import { Trash } from 'Screens/Contextualization/Manage/components/CustomActionBar/styled';
import ModalWarning from 'Common/Components/ModalWarning';
import { selectIsReadOnly } from 'store/Faraday/selectors';
import { selectAllowedByRole } from 'Hooks/usePermission/selector';

const DeleteHostButton = ({ hasHosts, showHostModalDelete, hostsSelected, showHostDetail, entity }) => {
  const readOnly = useSelector(selectIsReadOnly);
  const allowedByRole = useSelector((state) => selectAllowedByRole(state, FEATURE_HOSTS, PERMISSION_TYPES.DELETE));
  const [showWarning, setShowWarning] = useState(false);
  const canUpdate = entity === 'assets'
    ? !readOnly && !showHostDetail && allowedByRole && hasHosts
    : !showHostDetail && allowedByRole && hasHosts;
  const intl = useIntl();
  const message = intl.formatMessage({ id: 'modalWarning.selectOneOrMore' }, { entity: 'assets' });

  const handleClick = () => {
    if (canUpdate) {
      if (hostsSelected.length > 0) showHostModalDelete();
      else setShowWarning(true);
    }
  };

  const onClose = () => setShowWarning(false);

  return (
    <>
      <Button variant="ghost" startIcon={ <Trash /> } title="Delete" ariaLabel="Delete" onClick={ handleClick } disabled={ (entity === 'assets' && readOnly) || showHostDetail || !allowedByRole || !hasHosts } />
      { showWarning && <ModalWarning onCloseCallback={ onClose } title="Delete" description={ message } /> }
    </>
  );
};

export default DeleteHostButton;
